import { useState } from 'react';
import { Link } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { Form, Segment, Divider } from 'semantic-ui-react';
import styled from 'styled-components';
import useLocalStorage from '../../../libs/useLocalStorage';
import { api_url } from '../../../config';
import Center from '../../../components/Auth/Center';
import HeaderName from '../../../components/Auth/HeaderName';
import CenterWidth from '../../../components/Auth/CenterWidth';
import CenterMessage from '../../../components/CenterMessage';
import ButtonStretch from '../../../components/ButtonStretch';
import FlexBox from '../../../components/FlexBox';

const CustomFlexBox = styled(FlexBox)`
	justify-content: space-around;
`;

function Login({ history }) {
	const [ jwt_token, setJwtToken ]   = useLocalStorage(`jwt_token`);
	const [ , setUser ]                = useLocalStorage(`user`);
	const [ loading, setLoading ]      = useState(false);
	const [ login_data, setLoginData ] = useState({});
	const [ error, setError ]          = useState(false);

	if(jwt_token) {
		window.location = `/`;
	}

	function handleChange(e) {
		setLoginData({
			...login_data,
			[e.target.name] : e.target.value
		});
	}

	function handleSubmit() {
		setError(false);

		if(!login_data.email || !login_data.password) {
			setError(`Invalid email or password`);
		}

		setLoading(true);

		fetch(`${api_url}/authenticate`, {
			method : `POST`,
			body   : JSON.stringify(login_data),
			headers : {
				'Content-Type' : `application/json`
			}
		}).then(response => response.json()).then(data => {
			if(data.error || !data.jwt) {
				setError(data.error);
				setLoading(false);

				return;
			}

			const decoded = jwt_decode(data.jwt);

			setJwtToken(data.jwt);
			setUser(decoded.sub.user);

			setLoading(false);
		});
	}

	return (
		<Center>
			<CenterWidth>
				<HeaderName />

				<Form>
					<Form.Field>
						<label>Email</label>
						<input placeholder="Email" name="email" onChange={handleChange}></input>
					</Form.Field>
					<Form.Field>
						<label>Password</label>
						<input type="password" placeholder="Password" name="password" onChange={handleChange}></input>
					</Form.Field>

					<ButtonStretch loading={loading} positive type="submit" onClick={handleSubmit}>Log In</ButtonStretch>
				</Form>

				{error &&
					<CenterMessage negative>
						<p>{error}</p>
					</CenterMessage>
				}

				<Divider />

				<Segment>
					<CustomFlexBox>
						<div>
							{/* <Link to="/signup">Sign Up</Link> */}
						</div>

						<div>
							<Link to="/request-password-reset">Forgot Password</Link>
						</div>
					</CustomFlexBox>
				</Segment>
			</CenterWidth>
		</Center>
	);
}

export default Login;
